import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { PropertyDeleteRequestBody, PropertyDeleteResponse } from "./types";

export class PropertyDeleteAPI extends BaseAPI<
    PropertyDeleteRequestBody,
    PropertyDeleteResponse
> {
    protected route = ApiRoutes.property.delete;
    protected method = RequestMethod.DELETE;
    protected params = ["id"];
};
